import { defineStore } from 'pinia'
import { actions, getters, state } from './ext/items.js'


export const useApiTokenStore = defineStore('apiToken', {
  id: 'apiToken',
  state: () => ({
    items: [],
    api: '/api/v1/api-tokens'
  }),
  getters: {
    ...getters,
    getItemByTokenable: (state) => (tokenable) => {
      return state.items.filter(item => item.tokenable_id === tokenable.id && item.tokenable_type === tokenable.object_type);
    }
  },
  actions: {
    ...actions
  }
})
